import { FC } from "react";
import AvScanPendingSvg from "../../public/icons/AvScanPending.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const AvScanPendingIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><AvScanPendingSvg/></span>;
